import React, { useState } from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import ColorBook from './components/ColorBook/ColorBook';
import StoryBook from './components/StoryBook/StoryBook';
import HomePage from './components/HomePage/HomePage';
import StoryFlipBook from "./components/StoryBook/StoryFlipBook";
import NotFound from './components/NotFound/NotFound';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { useLanguage } from './contexts/LanguageContext';
import './styles.css';

const SITE_START_YEAR = 2025;

function App() {
    const { translate, lang, setLanguage, languages } = useLanguage();

    // Built once and served for months, so the year has to come from the
    // visitor's clock rather than from whenever the bundle was compiled.
    const thisYear = new Date().getFullYear();
    const copyright = thisYear > SITE_START_YEAR
        ? `© ${SITE_START_YEAR}–${thisYear}`
        : `© ${SITE_START_YEAR}`;

    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="app">
            <a className="skip-link" href="#main">{translate('skip_to_content')}</a>

            {/* Header */}
            <header className="header">
                <div className="logo">
                    <Link to="/" aria-label={translate('home_link')}>
                        <img
                            src="/assets/img/menu/cloud.png"
                            alt="Message for children"
                            className="logo-image"
                        />
                    </Link>
                </div>

                {/* Hamburger Menu Button (Mobile View) */}
                <button
                    className="menu-toggle"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-expanded={menuOpen}
                    aria-controls="main-menu"
                    aria-label={translate(menuOpen ? 'close_menu' : 'open_menu')}
                    style={{ fontSize: menuOpen ? "1.2rem" : "2rem" }}
                >
                    <span aria-hidden="true">{menuOpen ? "╳" : "☰"}</span>
                </button>

                {/* Navigation Menu */}
                <nav id="main-menu" className={`menu ${menuOpen ? "open" : ""}`}>
                    <Link to="/colorbook" className="menu-item" onClick={() => setMenuOpen(false)}>
                        <img src="/assets/img/menu/paint.png" alt="" className="menu-icon" />
                        {translate('colorBook')}
                    </Link>
                    <Link to="/storybook" className="menu-item" onClick={() => setMenuOpen(false)}>
                        <img src="/assets/img/menu/book.png" alt="" className="menu-icon" />
                        {translate('storyBook')}
                    </Link>
                    <div className="language-select">
                        <label htmlFor="language" className="visually-hidden">
                            {translate('choose_language')}
                        </label>
                        <select
                            id="language"
                            onChange={(e) => setLanguage(e.target.value)}
                            value={lang}
                        >
                            {languages.map(({ code, label }) => (
                                <option key={code} value={code}>{label}</option>
                            ))}
                        </select>
                    </div>
                </nav>
            </header>

            {/* Main Content */}
            <main className="main-content" id="main">
                <ErrorBoundary
                    messages={{
                        title: translate('error_title'),
                        body: translate('error_body'),
                        button: translate('back_home'),
                    }}
                >
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/colorbook" element={<ColorBook />} />
                    <Route path="/storybook" element={<StoryBook />} />
                    <Route path="/storybook/:storyId" element={<StoryFlipBook />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                </ErrorBoundary>
            </main>

            {/* Footer */}
            <footer className="footer">
                <p>{copyright} by message for children. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default App;
